import axios from "@/api/config/request"
import { BASE_API } from './index'

/**
 * 获取用户列表(子账号)
 * @param {Object} params
 * @param {number} params.pageIndex 当前页码
 * @param {number} params.pageSize 每页显示条数
 * @param {string} params.companyId 用户名
 * @returns {Promise}
 */
export function getPage(params) {
  return axios.get(`${BASE_API}/user/page`, { params })
}

/**
 * 添加/编辑(员工)用户
 * @param {Object} data
 * @returns {Promise}
 */
export function save(data) {
  return axios.post(`${BASE_API}/user/save`, data)
}

/**
 * 删除(员工)用户
 * @param {string} id
 * @returns {Promise}
 */
export function remove(id) {
  return axios.delete(`${BASE_API}/user/${id}`)
}

/**
 * 重置密码
 * @param {object} data
 * @param {number} data.id
 * @param {string} data.password
 * @returns {Promise}
 */
export function resetPassword(data) {
  return axios.post(`${BASE_API}/account/password/reset`, data)
}

/**
 * 启用/禁用(员工)用户
 * @param {object} data
 * @param {number} data.id
 * @param {boolean} data.status
 * @returns {Promise}
 */
export function enable(data) {
  return axios.put(`${BASE_API}/user/enable`, data)
}

/**
 * 个人修改账号信息
 * @param {object} data
 * @returns {Promise}
 */
export function savePersonalInfo(data) {
  return axios.post(`${BASE_API}/user/personal/save`, data)
}
export function logout() {
  return axios({
    url: `${BASE_API}/user/logout`,
    method: "post",
  });
}